export default function useDataConfiguration(props) {
  return {
    variables: {
      id: props.data.id,
    },
  }
}
